/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MenuOrderSubItem } from './MenuOrderSubItem';
import {
    MenuOrderSubItemFromJSON,
    MenuOrderSubItemFromJSONTyped,
    MenuOrderSubItemToJSON,
    MenuOrderSubItemToJSONTyped,
} from './MenuOrderSubItem';

/**
 * Represents a single item in the menu order.
 * @export
 * @interface MenuOrderItem
 */
export interface MenuOrderItem {
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItem
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItem
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItem
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItem
     */
    taxRate: number;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItem
     */
    notes?: string;
    /**
     * URLs for digital item redemption (one per quantity)
     * @type {Array<string>}
     * @memberof MenuOrderItem
     */
    redemptionUrls?: Array<string>;
    /**
     * Tillo references for digital item redemption (one per quantity)
     * @type {Array<string>}
     * @memberof MenuOrderItem
     */
    redemptionReferences?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MenuOrderItem
     */
    requiresShipping?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItem
     */
    fulfillmentType?: string;
    /**
     * 
     * @type {object}
     * @memberof MenuOrderItem
     */
    fulfillmentPayload?: object;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItem
     */
    printfulSyncProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuOrderItem
     */
    menuItemId?: string;
    /**
     * LootBox config ID — set for virtual LootBox cart items (mutually exclusive with menuItemId)
     * @type {string}
     * @memberof MenuOrderItem
     */
    lootBoxConfigId?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItem
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof MenuOrderItem
     */
    tax: number;
    /**
     * 
     * @type {Array<MenuOrderSubItem>}
     * @memberof MenuOrderItem
     */
    customizations?: Array<MenuOrderSubItem>;
}

/**
 * Check if a given object implements the MenuOrderItem interface.
 */
export function instanceOfMenuOrderItem(value: object): value is MenuOrderItem {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('subtotal' in value) || value['subtotal'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    return true;
}

export function MenuOrderItemFromJSON(json: any): MenuOrderItem {
    return MenuOrderItemFromJSONTyped(json, false);
}

export function MenuOrderItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuOrderItem {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'name': json['name'],
        'price': json['price'],
        'quantity': json['quantity'],
        'taxRate': json['taxRate'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'redemptionUrls': json['redemptionUrls'] == null ? undefined : json['redemptionUrls'],
        'redemptionReferences': json['redemptionReferences'] == null ? undefined : json['redemptionReferences'],
        'requiresShipping': json['requiresShipping'] == null ? undefined : json['requiresShipping'],
        'fulfillmentType': json['fulfillmentType'] == null ? undefined : json['fulfillmentType'],
        'fulfillmentPayload': json['fulfillmentPayload'] == null ? undefined : json['fulfillmentPayload'],
        'printfulSyncProductId': json['printfulSyncProductId'] == null ? undefined : json['printfulSyncProductId'],
        'menuItemId': json['menuItemId'] == null ? undefined : json['menuItemId'],
        'lootBoxConfigId': json['lootBoxConfigId'] == null ? undefined : json['lootBoxConfigId'],
        'subtotal': json['subtotal'],
        'tax': json['tax'],
        'customizations': json['customizations'] == null ? undefined : ((json['customizations'] as Array<any>).map(MenuOrderSubItemFromJSON)),
    };
}

export function MenuOrderItemToJSON(json: any): MenuOrderItem {
    return MenuOrderItemToJSONTyped(json, false);
}

export function MenuOrderItemToJSONTyped(value?: MenuOrderItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'name': value['name'],
        'price': value['price'],
        'quantity': value['quantity'],
        'taxRate': value['taxRate'],
        'notes': value['notes'],
        'redemptionUrls': value['redemptionUrls'],
        'redemptionReferences': value['redemptionReferences'],
        'requiresShipping': value['requiresShipping'],
        'fulfillmentType': value['fulfillmentType'],
        'fulfillmentPayload': value['fulfillmentPayload'],
        'printfulSyncProductId': value['printfulSyncProductId'],
        'menuItemId': value['menuItemId'],
        'lootBoxConfigId': value['lootBoxConfigId'],
        'subtotal': value['subtotal'],
        'tax': value['tax'],
        'customizations': value['customizations'] == null ? undefined : ((value['customizations'] as Array<any>).map(MenuOrderSubItemToJSON)),
    };
}

